import React, { useState } from 'react';
import AdminLayout from '@app/layout/AdminLayout.tsx';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { useParams } from 'react-router-dom';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import useNavigation from '@hooks/useNavigation';
import RingilButton from '@components/ringil3/Buttons/RingilButton.tsx';
import { CalendarLayoutModelDetailOutDTO } from '@api/ringil-api.v2';
import { CalendarLayoutModelEditor } from '@components/features/calendar-layout/management/CalendarLayoutModelEditor';

/**
 * Admin view of one calendar layout model. Admin pages carry no breadcrumb strip, so this one keeps
 * an explicit way back to the list.
 */
const IndexPage: React.FC = () => {
  const { tr } = useTranslationLgs();
  const navigation = useNavigation();
  const { modelId } = useParams();
  const [detail, setDetail] = useState<CalendarLayoutModelDetailOutDTO | null>(null);

  return (
    <AdminLayout title={detail?.name ?? tr('CalendarLayout.pageTitle', 'Calendar card layouts')}>
      <div className="flex flex-row items-center gap-3">
        <RingilButton
          label={tr('CalendarLayout.back', 'Back to models')}
          mode="outlined-rectangle"
          onClick={() => navigation.navigate(navigation.urlFunctions.adminCalendarLayout())}
        />
      </div>

      <div className="mt-4">
        <CalendarLayoutModelEditor
          modelId={modelId}
          admin
          onLoaded={setDetail}
          onDeleted={() => navigation.navigate(navigation.urlFunctions.adminCalendarLayout())}
          onOpenModel={newModelId => navigation.navigate(navigation.urlFunctions.adminCalendarLayoutModel(newModelId))}
        />
      </div>
    </AdminLayout>
  );
};

export default withAuthenticationRequired(IndexPage);
